import { ovl } from "."
import { ovlFetch, SYSFetchResult } from "./effects"
import { _ProcessReturnType } from "./library/longrunningprocesstracker/longrunningprocesstracker"

type DataOptions = {
  customUrl?: string
  method?: "POST" | "GET"
  suppressFeedbackSnack?: boolean
  expectBlob?: boolean
  isFormData?: boolean
  isAuthCheck?: boolean
  process?: _ProcessReturnType
}

export const Data = async (
  endpoint,
  data?,
  options?: DataOptions
): Promise<SYSFetchResult> => {
  if (data === undefined) {
    data = {}
  }
  let url = options?.customUrl
  if (!url) {
    url = `${ovl.getState().ovl.apiUrl}${endpoint}`
  }
  let method = options?.method
  if (!method) {
    method = "POST"
  }
  let expectBlob = options?.expectBlob
  if (expectBlob === undefined) {
    expectBlob = false
  }
  let suppressFeedbackSnack = options?.suppressFeedbackSnack === true
  let isFormData = options?.isFormData
  if (isFormData === undefined) {
    isFormData = false
  }
  return await ovlFetch(
    url,
    data,
    method,
    expectBlob,
    suppressFeedbackSnack,
    undefined,
    isFormData,
    options?.isAuthCheck,
    options?.process
  )
}
